export default __webpack_public_path__ + "static/media/401k_light.647d23ad.png";